import { useTranslations } from '@lang';
import { FC } from 'react';
import { Loader, SpinnerWrapper, StyledDelayMessage } from './Spinner.styles';
import { SpinnerProps } from './Spinner.types';

export const Spinner: FC<SpinnerProps> = ({
  isBackgroundDisabled = false,
  isActive = false,
  isLocal = false,
  showDelayMessage = false,
}) => {
  const { t } = useTranslations();
  return isActive ? (
    <SpinnerWrapper isBackgroundDisabled={isBackgroundDisabled} isLocal={isLocal}>
      <Loader />
      {showDelayMessage && (
        <StyledDelayMessage>{t('app.spinner.oneMomentPlease')}</StyledDelayMessage>
      )}
    </SpinnerWrapper>
  ) : null;
};
